const config = {
    // dev pps
    // api: {
    //     BASE_URL: 'https://dev.reportspps.com:9184',
    //     FETCH_URL: 'https://dev.reportspps.com:9185',
    //     KEYS_URL: 'https://dev.reportspps.com:9186',
    //     POS_SYSTEM_URL : 'https://dev.reportspps.com:4121',
    // }
    // dev barma portal
    // api: {
    //     BASE_URL: 'https://dev.reportspps.com:9284',
    //     FETCH_URL: 'https://dev.reportspps.com:9285',
    //     KEYS_URL: 'https://dev.reportspps.com:9286',
    // }
    // prod Station Reports
    api: {
        BASE_URL: 'https://station-reports.com:5211',
        FETCH_URL: 'https://station-reports.com:5212',
        KEYS_URL: 'https://station-reports.com:5213',
    }

}


export default config;